import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskServicesWithoutProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-services-without-project',
	path: '/jira/servicedesk/services',
	exact: true,
};
